import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/PlayerChartSetting/Get', params)
    },
    getList: params => {
        return API.GET('/api/PlayerChartSetting/List', params)
    },
    add: params => {
        return API.POST('/api/PlayerChartSetting/Add', params)
    },
    edit: params => {
        return API.POST('/api/PlayerChartSetting/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/PlayerChartSetting/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/PlayerChartSetting/DeleteBatch', params)
    },
    getChart: params => {
        return API.GET('/api/PlayerChartSetting/GetChart', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/playerchart.js